import { z } from 'zod';
export const timesheetsActivityReviewHostCapability = 'timesheets.activity-review-host.v1';
export const timesheetsActivityReviewHostSlots = {
    summary: 'timesheets.activity-review.summary',
};
export const timesheetsActivityReviewHostResourceType = 'timesheets.membership-activity-window';
export const timesheetsActivityReviewHostContextSchema = z.strictObject({
    resourceType: z.literal(timesheetsActivityReviewHostResourceType),
    resourceId: z.string().uuid(),
    parameters: z.strictObject({
        resourceLabel: z.string().trim().min(1).max(200),
        fromInclusive: z.string().datetime({ offset: true }),
        toExclusive: z.string().datetime({ offset: true }),
    }),
}).superRefine((value, context) => {
    if (Date.parse(value.parameters.toExclusive) <= Date.parse(value.parameters.fromInclusive)) {
        context.addIssue({
            code: 'custom',
            path: ['parameters', 'toExclusive'],
            message: 'The Timesheets activity-review end must follow its start.',
        });
    }
});
//# sourceMappingURL=timesheets-activity-review-host.contract.js.map